import { useGetSupportPhoneNumber } from "../routes/support-phone-number-routes";

export default function useSupportPhoneNumber(enumLine) {
  const getSupportPhoneNumber = useGetSupportPhoneNumber(enumLine);
  return {
    ...getSupportPhoneNumber,
    phone: getSupportPhoneNumber.data?.phone,
  };
}
